import React from 'react';
import ChamadoDescriptionField from '../../../Solicitante/NovaSati/components/ChamadoDescriptionField';
import ChamadoTypeField from '../../../Solicitante/NovaSati/components/ChamadoTypeField';
import ChamadoSectorField from '../../../Solicitante/NovaSati/components/ChamadoSectorField';
import ChamadoEmailField from '../../../Solicitante/NovaSati/components/ChamadoEmailField';
import ChamadoAttachmentField from '../../../Solicitante/NovaSati/components/ChamadoAttachmentField';
import ChamadoSubmitButton from '../../../Solicitante/NovaSati/components/ChamadoSubmitButton';
import ChamadoSolicitanteField from './ChamadoSolicitanteField';

function ChamadoCreateFormAnalista({
    numero,
    selected,
    onSolicitanteChange,
    data,
    descricao,
    setDescricao,
    tipo,
    setTipo,
    setor,
    setSetor,
    codSis,
    setCodSis,
    codEqp,
    setCodEqp,
    listSistemas,
    listaEquipamento,
    tipos,
    emailAdicional,
    setEmailAdicional,
    nomeAnexo,
    onAnexoChange,
    onSubmit,
    salvando,
    mensagem,
}) {
    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit(e);
    };

    return (
        <form className="chamado-create-form" onSubmit={handleSubmit}>
            <section className="chamado-create-section" aria-labelledby="section-identificacao">
                <h2 id="section-identificacao" className="chamado-create-section-title">Identificação</h2>
                <div className="chamado-create-field">
                    <label htmlFor="chamado-numero">Número</label>
                    <input id="chamado-numero" type="text" value={numero} readOnly disabled />
                </div>
                <ChamadoSolicitanteField value={selected} onChange={onSolicitanteChange} data={data} />
            </section>

            <section className="chamado-create-section" aria-labelledby="section-descricao">
                <h2 id="section-descricao" className="chamado-create-section-title">Descrição</h2>
                <ChamadoDescriptionField value={descricao} onChange={setDescricao} />
            </section>

            <section className="chamado-create-section" aria-labelledby="section-classificacao">
                <h2 id="section-classificacao" className="chamado-create-section-title">Classificação</h2>
                <ChamadoTypeField value={tipo} onChange={setTipo} tipos={tipos} />
                <ChamadoSectorField
                    value={setor}
                    onChange={setSetor}
                    codSis={codSis}
                    setCodSis={setCodSis}
                    codEqp={codEqp}
                    setCodEqp={setCodEqp}
                    listSistemas={listSistemas}
                    listaEquipamento={listaEquipamento}
                />
            </section>

            <section className="chamado-create-section" aria-labelledby="section-contato">
                <h2 id="section-contato" className="chamado-create-section-title">Contato e anexo</h2>
                <ChamadoEmailField value={emailAdicional} onChange={setEmailAdicional} />
                <ChamadoAttachmentField nomeArquivo={nomeAnexo} onFileChange={onAnexoChange} />
            </section>

            <ChamadoSubmitButton loading={salvando} disabled={false} />

            {mensagem && (
                <div className="chamado-create-message error" role="alert">
                    {mensagem}
                </div>
            )}
        </form>
    );
}

export default ChamadoCreateFormAnalista;
